/**
 * Convert a query string to an object
 * @param {string} query query string to convert
 * @return {object} query string parameters
 */
export default function fromQueryString(query = null) {
    if (query === null) {
        query = window.location.search?.replace('?', '');
    }
    if (!query) {
        return {};
    }

    const parsed = {};
    query.split('&').forEach((param) => {
        // check for array params and convert to array
        if (param.match(/.*\[\]=.*/)) {
            const [key, value] = param.split('[]=');
            if (!parsed[key]) {
                parsed[key] = [];
            }
            parsed[key].push(decodeURIComponent(value));
        } else {
            const [key, value] = param.split('=');
            parsed[key] = decodeURIComponent(value);
        }
    });

    return parsed;
}
